import { isOpenableUrl } from '../../context/platform/isOpenableUrl'

const BOOT_ID_STORAGE_KEY = 'vipost-boot-id'

export class ElectronPlatform {
    get name() {
        return 'electron'
    }

    get router() {
        return 'hash'
    }

    get env() {
        return process.env
    }

    get isDesktopApp() {
        return true
    }

    get scannedImagesLocation() {
        return window.electron.config.scannedImagesLocation
    }

    async getAppVersion() {
        // const { app } = await import('electron')
        // const version = app.getVersion()
        // return version
        const { version } = await import('../../../package.json')
        return version
    }

    async checkForUpdates() {
        return window.electron.versioning.checkForUpdates()
    }

    readFileSync(path) {
        const file = window.electron.fs.readFileSync(path)
        console.log('electron read file', path, 'length:', file?.length)
        return file
    }

    existsSync(path) {
        return Boolean(window.electron.fs.existsSync(path))
    }

    readdirSync(path) {
        return window.electron.fs.readdirSync(path)
    }

    statSync(path) {
        return window.electron.fs.statSync(path)
    }

    showMessageBoxSync(options) {
        const { dialog } = window.electron
        dialog.showMessageBoxSync(null, options)
    }

    onMessage(callback) {
        window.electron.messaging.onMessage(callback)
    }

    // Opens outside the application rather than navigating it; the main process
    // repeats this same validation before it ever calls shell.openExternal.
    openExternalUrl(url) {
        if (!isOpenableUrl(url)) {
            return false
        }
        window.electron.shell.openExternalUrl(url)
        return true
    }

    // The main process mints a boot identifier once per application start, so it
    // survives a renderer refresh. Seeing a value we have not recorded means the
    // application was restarted — a new session.
    isSessionStart() {
        const bootId = window.electron?.session?.bootId?.()
        if (bootId == null) {
            return true
        }

        const seen = window.localStorage.getItem(BOOT_ID_STORAGE_KEY)
        window.localStorage.setItem(BOOT_ID_STORAGE_KEY, bootId)

        return seen !== bootId
    }
}
